import React, { useEffect } from 'react';
// import Footer from 'src/layout/Footer/Footer';
// import Header from 'src/layout/Header/Header';
import { useTranslation } from 'react-i18next';
import { TPageProps } from './Page.types';
import './page.css';

const Page: React.FC<TPageProps> = (props: TPageProps): React.ReactElement => {
  const {
    children, pageClass, pageHeader, otherProps,
  } = props;
  const ref = React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language) {
      document.documentElement.lang = i18n.language;
      document.documentElement.dir = i18n.dir(i18n.language);
    }
  }, [i18n, i18n.language]);

  useEffect(() => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && window.innerWidth > 1000) {
          entry.target.classList.add('in-viewport');
        } else {
          entry.target.classList.remove('in-viewport');
        }
      });
    });
    const contentBlocks = document.querySelectorAll('.scroll-animated');
    for (let i = 0; i < contentBlocks.length; i += 1) {
      observer.observe(contentBlocks[i]);
    }

    let scrollPosition = window.scrollY;
    const joinContainer = document.querySelector('.join-container');
    window.addEventListener('scroll', () => {
      scrollPosition = window.scrollY;

      if (
        ((window.innerWidth > 770
            && scrollPosition >= document.body.scrollHeight - 1100)
          || (window.innerWidth <= 769
            && scrollPosition >= document.body.scrollHeight - 1400))
        && !joinContainer?.classList.contains('scrolled')
      ) {
        joinContainer?.classList.add('scrolled');
      } else if (
        (window.innerWidth > 770
          && scrollPosition < document.body.scrollHeight - 1100)
        || (window.innerWidth <= 769
          && scrollPosition < document.body.scrollHeight - 1400)
      ) {
        joinContainer?.classList.remove('scrolled');
      }
    });

    return () => {
      for (let i = 0; i < contentBlocks.length; i += 1) {
        observer.unobserve(contentBlocks[i]);
      }
    };
  }, [ref]);
  return (
    <div className={`page ${pageClass ?? ''}`} ref={ref}>
      {/*<Header/>*/}
      {pageHeader && pageHeader !== '' ? (
        <h1 className={'page-header'}>{pageHeader}</h1>
      ) : (
        ''
      )}
      <div {...(otherProps as object)} className={'content-container'}>
        {children}
      </div>
      {/*<Footer/>*/}
    </div>
  );
};

export default Page;
